import { dataIntelligence } from 'dls-icons-data'
import { createIcon } from '../common'

const IconIntelligence = /*#__PURE__*/createIcon(dataIntelligence)
export default IconIntelligence
